import React from 'react';

import PropTypes from 'prop-types';
import { Search } from '@telus-uds/components-web';

const Filter = ({ filterString, setFilterString }) => {
  return (
    <div style={{ width: '100%', maxWidth: '300px' }}>
      <Search
        label="Search"
        placeholder="Search by dealership..."
        value={filterString}
        onChange={(value) => setFilterString(value)}
      />
    </div>
  );
};
Filter.propTypes = {
  filterString: PropTypes.string.isRequired,
  setFilterString: PropTypes.func.isRequired
};
export default Filter;
